<template>
    <div class="col-12">
        <template v-if="uniqueDates.length > 1">
            <h4 class="headingLevel mb-4">{{ getTranslation('licence-configurator', 'subscription_options') }}</h4>
            <!-- keep subscriptions separate -->
            <b-form-radio
                :id="'lease_custom_' + product.id"
                :name="'configure_period_'+ product.id"
                v-model="leaseOptions.selectedOption"
                value="1"
                class="mb-3 mt-4"
                @change="setSeparate()"
            >
                <span class="font-weight-medium">{{ getTranslation('licence-configurator', 'keep_subscriptions_separate') }}</span>
            </b-form-radio>


            <b-form-radio
                :id="'lease_merge_' + product.id"
                :name="'configure_period_'+ product.id"
                v-model="leaseOptions.selectedOption"
                value="2"
                class="mb-3 mt-4"
                @change="mergeSubscriptions()"
            >
                <span class="font-weight-medium">{{ getTranslation('licence-configurator', 'merge_subscriptions') }}</span>
            </b-form-radio>

            <div class="custom-control custom-checkbox b-custom-control-lg mb-2" v-for="date in leaseUniqueDates[product.id]" :key="date">
                <input
                    type="checkbox"
                    :id="'lease_merge_' + product.id + '_' + date"
                    class="custom-control-input"
                    :name="'lease_merge_' + product.id + '_' + date"
                    :disabled="leaseOptions.selectedOption !=2 || uniqueDates.includes(date)"
                    @click="addLeaseMerge($event)"
                    :value="date"
                    :checked="leaseOptions.dates && leaseOptions.dates.includes(date) && leaseOptions.selectedOption === 2"
                >
                <label :for="'lease_merge_' + product.id + '_' + date" class="custom-control-label d-flex flex-wrap" style="font-size: 16px;">
                    <span style="font-weight: 400;">{{ date }}</span>&nbsp;-&nbsp;{{ getProgramText(date) }}
                </label>
            </div>
        </template>

        <div class="mt-4">
            <label :for="'customDate_' + product.id" class="form-label font-weight-medium mb-2">{{ getTranslation('licence-configurator', 'set_custom_end_date') }}</label>
            <input
                type="date"
                :id="'customDate_' + product.id"
                class="form-control d-inline-block"
                style="width: 200px; font-size: 16px;"
                :value="leaseOptions.customDate"
                :min="leaseOptions.minDate"
                :max="leaseOptions.maxDate"
                @input="selectCustomDate($event)"
                placeholder="Select custom end date"
                :disabled="leaseOptions.customdate === false"
            >
        </div>

        <div class="mt-4" v-if="hasCustomization()">
            <cart-info-prolong-customization v-bind:product="product"></cart-info-prolong-customization>
        </div>
    </div>
</template>

<script>


export default {
        methods: {
            hasCustomization() {
                let items = _.filter(this.$store.state.cart.leaseProlong[this.product.id]['info'], function(l) {
                    return (l.days !== false && l.selected === 1 );
                });
                return !_.isEmpty(items);
            },
            getInputMinDate(date) {
                return date;
            },
            getInputMaxDate() {
                let now = new Date();
                return this.getFormattedDate(new Date(now.setFullYear(now.getFullYear() + 3)));
            },
            updateLeaseOptions(data) {
                let payload = {
                    id: this.product.id,
                    data: data,
                }
                this.$store.commit('updateLeaseOptions', payload);
            },
            getFormattedDate(date = false) {
                if (date === false) {
                    date = new Date();
                }
                let year = date.getFullYear();
                // Month is 0-indexed, so add 1
                let month = String(date.getMonth() + 1).padStart(2, '0');
                let day = String(date.getDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            },
            treatAsUTC(date) {
                let result = new Date(date);
                result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
                return result;
            },
            daysBetween(startDate, endDate) {
                let millisecondsPerDay = 24 * 60 * 60 * 1000;
                let ret = (this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) / millisecondsPerDay;
                return Math.ceil(ret);
            },
            getProgramText(date) {
                let self = this;
                let programs = _.filter(this.licences, function(l) { return (l.lease_end == date && l.product == self.product.id); });
                let pr = [];
                _.forEach(programs, function (p) {
                    let name = p.program_name;
                    if (p.qty > 1) {
                        name = 'x' + p.qty + ' '  + p.program_name;
                    }
                    pr.push(name);
                })
                return pr.join(", ");
            },
            updateCartLeases(value) {
                let self = this;
                if (_.isNil(value) || _.isNaN(value)) {
                    value = false;
                }

                _.forEach(this.$store.state.cart.leaseProlong[this.product.id].info, function(p) {
                    let days = false;
                    if (value) {
                        days = self.daysBetween(p.version, value);
                    }
                    let payload = {
                        product: self.product.id,
                        id: p.id,
                        upgrade: days,
                        column: 'days',
                        user_licence_id: p.user_licence_id
                    }
                    self.$store.commit('upgradeCartProgramProlong', payload);
                });
            },

            deleteCartProlongData() {
                //delete the lease merge data
                let payload = {product: this.product.id};
                this.$store.commit('deleteLeaseProlongConfig', payload);

                //reset cart step
                this.resetCartStep();
            },
            compareDates(date1, date2) {
                if (date1 === date2) {
                    return 0;
                } else if (this.daysBetween(date1, date2) > 0) {
                    return 1
                } else {
                    return -1;
                }
            },
            resetDatePicker(minDate = false) {
                let customDateContainer = $('#customDate_' + this.product.id);
                customDateContainer.val('');
                this.leaseOptions.customDate = false;
                if (minDate) {
                    customDateContainer.attr('min', minDate);
                    this.leaseOptions.minDate = minDate;
                }
            },

            resetCartStep() {
                let payload = {'step': 2};
                this.$store.commit('setCartStep', payload);
            },
            licenceIsInProlong(id) {
                let items = _.filter(this.$store.state.cart.leaseProlong[this.product.id]['info'], function(l) {
                    return (l.user_licence_id === id );
                });
                return !_.isEmpty(items);

            },
            updateLeaseConfig() {
                let self = this;
                if (this.leaseOptions.selectedOption === 2) {
                    let allDates = _.clone(this.leaseOptions.dates);
                    if (this.leaseOptions.customDate) {
                        allDates.push(this.leaseOptions.customDate);
                    }
                    let maxDate = this.getFormattedDate(new Date(Math.max(...allDates.map(date => new Date(date)))));

                    let licences =_.filter(this.licences, function(l) { return (l.product === self.product.id); });
                    _.forEach(licences, function (l) {
                        if (
                            (self.compareDates(l.lease_end, maxDate) > 0) &&
                            self.leaseOptions.dates.includes(l.lease_end) &&
                            !self.licenceIsInProlong(l.user_licence_id)
                        ) {
                            let daysDiff = self.daysBetween(l.lease_end, maxDate);
                            let payload = {
                                program_id: l.program_id,
                                discount: l.discount,
                                user_licence_id: l.user_licence_id,
                                leaseId: l.leaseId,
                                lease_end: l.lease_end,
                                lease_end_new: maxDate,
                                product: l.product,
                                daysDiff: daysDiff,
                                sort_order: l.sort_order,
                                quantity: l.quantity,
                            }
                            self.$store.commit('createLeaseProlongConfig', payload);
                        }
                    })
                }
            },

            setSeparate() {
                //reset cart prolong options
                this.deleteCartProlongData();

                this.leaseOptions = {
                    oneYear: true,
                    merge: false,
                    customDate: null,
                    daysDifference: false,
                    selectedOption: 1,
                    dates: [],
                    minDate: null,
                    maxDate: this.getInputMaxDate()
                };
                this.updateLeaseOptions(this.leaseOptions);
                this.updateCartLeases();
            },
            addLeaseMerge(event) {
                let currentDate = event.target.value;
                let dates = this.leaseOptions.dates;
                this.deleteCartProlongData();
                this.updateCartLeases();

                if (dates.includes(currentDate)) {
                    // remove the date
                    dates = dates.filter(d => d !== currentDate);
                } else {
                    dates.push(currentDate);
                }
                let daysDiff = false;
                let maxDate = this.getFormattedDate(new Date(Math.max(...dates.map(date => new Date(date)))));

                if (_.isEmpty(dates)) {
                    this.updateCartLeases(false);
                } else {
                    daysDiff = this.daysBetween(this.getFormattedDate(), maxDate);
                    this.updateCartLeases(maxDate);
                }

                this.resetDatePicker(maxDate);

                this.leaseOptions = {
                    oneYear: false,
                    merge: true,
                    customDate: maxDate,
                    daysDifference: false,
                    selectedOption: 2,
                    dates: dates,
                    minDate: this.getInputMinDate(maxDate),
                    maxDate: this.getInputMaxDate()
                }
                this.updateLeaseOptions(this.leaseOptions);

                this.updateLeaseConfig();
            },

            mergeSubscriptions() {
                //set as disabled the dates that are in lease prolong
                let uniqueDates = [...new Set(this.$store.state.cart.leaseProlong[this.product.id]['info'].map(item => item.version))];

                let maxDate = this.getFormattedDate(new Date(Math.max(...uniqueDates.map(date => new Date(date)))));
                this.resetDatePicker(maxDate);

                this.leaseOptions = {
                    oneYear: false,
                    merge: true,
                    customDate: maxDate,
                    daysDifference: false,
                    selectedOption: 2,
                    dates: uniqueDates,
                    minDate: this.getInputMinDate(maxDate),
                    maxDate: this.getInputMaxDate()
                }
                this.updateLeaseOptions(this.leaseOptions);
                this.updateCartLeases(maxDate);
            },

            selectCustomDate(event) {
                if (this.leaseOptions.selectedOption === 1) {
                    return;
                }
                this.deleteCartProlongData();
                this.updateCartLeases();
                let selectedDate = event.target.value;
                let dates = this.leaseOptions.dates;
                let maxDate = this.getFormattedDate();
                if (!_.isEmpty(dates)) {
                    maxDate = this.getFormattedDate(new Date(Math.max(...dates.map(date => new Date(date)))));
                }

                //selected date cannot be lower than maxDate
                if (this.compareDates(selectedDate, maxDate) > 0) {
                    this.resetDatePicker();
                    return false;
                }

                this.leaseOptions.customDate = selectedDate;
                this.updateLeaseOptions(this.leaseOptions);

                this.updateLeaseConfig();
                this.updateCartLeases(selectedDate);
            },
        },
        beforeMount() {
            if (_.isNil(this.$store.state.cart.leaseOptions[this.product.id]) || _.isEmpty(this.$store.state.cart.leaseOptions[this.product.id])) {
                this.setSeparate();
            } else {
                this.leaseOptions = this.$store.state.cart.leaseOptions[this.product.id];
            }
        },
        mounted() {

        },
        computed: {
            uniqueDates() {
                return [...new Set(this.$store.state.cart.leaseProlong[this.product.id]['info'].map(item => item.version))];
            }
        },
        data() {
            return {
                products: window.jsonProducts,
                leaseData: JSON.parse(window.leaseData),
                leaseUniqueDates: JSON.parse(window.leaseUniqueDates),
                referenceDates: JSON.parse(window.referenceDates),
                leaseOptions: {},
                licences: JSON.parse(window.licences),
            };
        },
        props: {
            product: Object,
        }
    }
</script>

<style>

</style>
